/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';
import { Id } from './id.zod.ts';
import { NotificationEntityType } from './notificationEntityType.zod.ts';

export const NotificationEntityRef = zod.object({
  "type": NotificationEntityType,
  "id": Id,
  "display_name": zod.string(),
  "links": zod.object({
  "api": zod.url().nullable().describe('URL of the resource in this API, or null when the resource has no endpoint.')
})
}).describe('A reference to a resource with the API URL the client can fetch for its details.');

export type NotificationEntityRef = zod.input<typeof NotificationEntityRef>;
export type NotificationEntityRefOutput = zod.output<typeof NotificationEntityRef>;
